<button
  class="icon-filter-button"
  mat-stroked-button
  [matMenuTriggerFor]="filterSelection"
  matBadgePosition="after"
  matBadgeColor="accent"
  [ngClass]="{ 'filter-selected-view': selectedFilter }"
  >
  <mat-icon class="icon">filter_list</mat-icon>
  <span class="label">
    {{ 'MEETING_SCHEDULER.MEETING_LIST.Filter_LABEL' | translate }}
  </span>
</button>

<mat-menu class="dropdown-menu" [overlapTrigger]="false" #filterSelection="matMenu">
  <div cdkFocusInitial mat-menu-item class="hide-item"></div>
  <!-- Prevent first item from being auto-focused -->
  @for (option of displayedMeetingTypes; track option) {
    <button
      [ngClass]="{ 'selected-item': selectedFilter === option.id }"
      mat-menu-item
      (click)="onselectionchange(option.id)"
      >
      <div class="dropdown-menu-item">
        <span> {{ option.displayName }} </span>
        @if (selectedFilter === option.id) {
          <mat-icon>done</mat-icon>
        }
      </div>
    </button>
  }
</mat-menu>

<mat-chip-listbox>
  @for (option of displayedMeetingTypes; track option) {
    @if (selectedFilter === option.id) {
      <mat-chip-option>
        {{ option.name }}
        <button matChipRemove aria-label="Remove option" (click)="onselectionchange('all')">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-option>
    }
  }
</mat-chip-listbox>
